<template>
  <!-- ========== 3 SCHRITTE ========== -->
  <section class="k-sec reveal" id="so-gehts">
    <div class="k-head">
      <span class="k-eyebrow">So einfach geht's</span>
      <h2>Drei Schritte bis zum ersten <span class="grad">Hallo</span>.</h2>
    </div>
    <div class="kr" data-kr>
      <!-- Desktop-Bühne: EINE ruhige Welle von links nach rechts (nur >=821px sichtbar) -->
      <svg class="kr-stage" viewBox="0 0 1440 520" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="krg" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="1440" y2="520">
            <stop offset="0" stop-color="#F17C08" />
            <stop offset="1" stop-color="#C63E7C" />
          </linearGradient>
        </defs>
        <path class="kr-path kr-main" d="M -60 260 C 60 220, 160 140, 260 140 C 380 140, 560 320, 720 320 C 880 320, 1060 140, 1180 140 C 1280 140, 1380 200, 1500 250" fill="none" stroke="url(#krg)" stroke-width="16" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <ol class="kr-list">
        <li class="kr-step" style="--ax:18.06%;--ay:26.9%">
          <svg class="kr-seg" viewBox="0 0 375 90" aria-hidden="true" focusable="false">
            <defs>
              <linearGradient id="krgA" gradientUnits="userSpaceOnUse" x1="187.5" y1="0" x2="187.5" y2="90">
                <stop offset="0" stop-color="#F17C08" />
                <stop offset="1" stop-color="#E4682D" />
              </linearGradient>
            </defs>
            <path class="kr-path" d="M 187.5 -10 C 187.5 25, 130 40, 130 60 C 130 82, 187.5 75, 187.5 100" fill="none" stroke="url(#krgA)" stroke-width="13" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div class="kr-in">
            <span class="kr-badge" aria-hidden="true">1</span>
            <h3>Profil anlegen</h3>
            <p>Kostenlos, mit E-Mail. Kein Abo, keine versteckten Haken — du entscheidest, wie es weitergeht.</p>
          </div>
        </li>
        <li class="kr-step" style="--ax:50%;--ay:61.5%">
          <svg class="kr-seg" viewBox="0 0 375 120" aria-hidden="true" focusable="false">
            <defs>
              <linearGradient id="krgB" gradientUnits="userSpaceOnUse" x1="187.5" y1="0" x2="187.5" y2="120">
                <stop offset="0" stop-color="#E4682D" />
                <stop offset="1" stop-color="#D95850" />
              </linearGradient>
            </defs>
            <path class="kr-path" d="M 187.5 -10 C 187.5 30, 260 45, 260 70 C 260 95, 187.5 90, 187.5 130" fill="none" stroke="url(#krgB)" stroke-width="13" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div class="kr-in">
            <span class="kr-badge" aria-hidden="true">2</span>
            <h3>Interessen wählen</h3>
            <p>Damit Gespräche sofort Stoff haben: Sag kurz, was dich begeistert und wen du kennenlernen möchtest.</p>
          </div>
        </li>
        <li class="kr-step" style="--ax:81.94%;--ay:26.9%">
          <svg class="kr-seg" viewBox="0 0 375 120" aria-hidden="true" focusable="false">
            <defs>
              <linearGradient id="krgC" gradientUnits="userSpaceOnUse" x1="187.5" y1="0" x2="187.5" y2="120">
                <stop offset="0" stop-color="#D95850" />
                <stop offset="1" stop-color="#CE4870" />
              </linearGradient>
            </defs>
            <path class="kr-path" d="M 187.5 -10 C 187.5 30, 115 45, 115 70 C 115 95, 187.5 90, 187.5 130" fill="none" stroke="url(#krgC)" stroke-width="13" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div class="kr-in">
            <span class="kr-badge" aria-hidden="true">3</span>
            <h3>Losschreiben</h3>
            <p>Dein erstes Hallo ist der ganze Trick. Den Rest ergibt das Gespräch von selbst.</p>
          </div>
        </li>
      </ol>

      <!-- Mobile-Outro: Auslauf + Herz (nur <=820px sichtbar) -->
      <svg class="kr-seg kr-outro" viewBox="0 0 375 130" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="krgD" gradientUnits="userSpaceOnUse" x1="187.5" y1="0" x2="187.5" y2="130">
            <stop offset="0" stop-color="#CE4870" />
            <stop offset="1" stop-color="#C63E7C" />
          </linearGradient>
        </defs>
        <path class="kr-path kr-main-m" d="M 187.5 -10 C 187.5 15, 187.5 30, 187.5 58" fill="none" stroke="url(#krgD)" stroke-width="13" stroke-linecap="round" stroke-linejoin="round" />
        <path class="kr-path kr-heart-m" d="M 187.5 58 C 176 46, 156 50, 156 68 C 156 86, 175 95, 187.5 106 C 200 95, 219 86, 219 68 C 219 50, 199 46, 187.5 58" fill="none" stroke="url(#krgD)" stroke-width="13" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="k-after">
      <button type="button" class="btn-primary" data-open-signup>Kostenlos registrieren <span class="arrow">→</span></button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'KennenlernenStepsSection',
};
</script>
